"use client";

import { useEffect, useRef } from "react";

interface UseScrollAnimationOptions {
  threshold?: number;
  rootMargin?: string;
  triggerOnce?: boolean;
}

export function useScrollAnimation<T extends HTMLElement>(
  options: UseScrollAnimationOptions = {}
) {
  const {
    threshold = 0.1,
    rootMargin = "0px 0px -60px 0px",
    triggerOnce = true,
  } = options;

  const ref = useRef<T>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("visible");
            entry.target.classList.remove("hidden-init");
            if (triggerOnce) {
              observer.unobserve(entry.target);
            }
          } else if (!triggerOnce) {
            entry.target.classList.remove("visible");
            entry.target.classList.add("hidden-init");
          }
        });
      },
      { threshold, rootMargin }
    );

    const elements = ref.current?.querySelectorAll(".reveal-up");
    elements?.forEach((el) => {
      el.classList.add("hidden-init");
      observer.observe(el);
    });

    return () => observer.disconnect();
  }, [threshold, rootMargin, triggerOnce]);

  return ref;
}
